(function () {
  /** 从卡片 / Quick View 弹层解析 GA4 module（弹层根会写入开来源 module） */
  function resolveGa4Module(el) {
    if (!(el instanceof Element)) return 'collection';
    var host = el.closest('[data-ga4-module]');
    if (host instanceof HTMLElement) {
      var module = host.getAttribute('data-ga4-module');
      if (module) return module;
    }
    /* 弹层未写入来源时再兜底 quick_view，避免误标成 collection */
    if (el.closest('#quick-add-dialog, quick-add-dialog')) {
      return 'quick_view';
    }
    return 'collection';
  }

  /** GA4：click_button（仅 skill 标准字段 module + button_name） */
  function trackClickButton(el, buttonName) {
    var track = window.ugGa4Track;
    if (!track || typeof track.clickButton !== 'function') return;

    try {
      track.clickButton({
        module: resolveGa4Module(el),
        button_name: buttonName,
      });
    } catch (_) {}
  }

  /** GA4：复制折扣码 */
  function trackCopyDiscountCode(el) {
    trackClickButton(el, 'copy_discount_code');
  }

  /** GA4：五点描述小眼睛 */
  function trackProductFeatures(el, isOpen) {
    trackClickButton(el, isOpen ? 'product_features_close' : 'product_features_open');
  }

  function handleCopyClick(event) {
    var button = event.target.closest('[data-ug-copy-data]');
    if (button) {
      event.preventDefault();
      event.stopPropagation();

      var textToCopy = button.getAttribute('data-ug-copy-data');
      if (!textToCopy || button.classList.contains('copied')) return;

      var copyText = button.getAttribute('data-copy-text') || button.getAttribute('data-copy-default') || button.textContent;
      var copiedText = button.getAttribute('data-copied-text') || button.getAttribute('data-copy-success') || 'Copied!';
      var failedText = button.getAttribute('data-copy-failed') || 'Copy failed';

      copyToClipboard(textToCopy).then(function (success) {
        if (!success) {
          button.textContent = failedText;
          setTimeout(function () {
            button.textContent = copyText || 'Copy';
          }, 2000);
          return;
        }
        trackCopyDiscountCode(button);
        button.textContent = copiedText;
        button.classList.add('copied');
        setTimeout(function () {
          button.textContent = copyText || 'Copy';
          button.classList.remove('copied');
        }, 2000);
      });
      return;
    }

    /* 商详折扣块（Quick View morph 后无 DOMContentLoaded 绑定） */
    var discountCopyBtn = event.target.closest('.copy-button[data-clipboard-text]');
    if (!discountCopyBtn) return;

    event.preventDefault();
    event.stopPropagation();

    var discountCode = discountCopyBtn.getAttribute('data-clipboard-text');
    if (!discountCode) return;

    var discountContent = discountCopyBtn.closest('.discount-code-content');
    var copiedBtn = discountContent ? discountContent.querySelector('.copied-button') : null;

    copyToClipboard(discountCode).then(function (success) {
      if (!success) return;

      trackCopyDiscountCode(discountCopyBtn);

      discountCopyBtn.style.display = 'none';
      if (copiedBtn) copiedBtn.style.display = 'inline-block';

      setTimeout(function () {
        discountCopyBtn.style.display = '';
        if (copiedBtn) copiedBtn.style.display = 'none';
      }, 2000);
    });
  }

  async function copyToClipboard(text) {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text);
        return true;
      }
    } catch (err) {
      console.error('Clipboard API error:', err);
    }

    return manualCopyFallback(text);
  }

  function manualCopyFallback(text) {
    try {
      var textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      var successful = document.execCommand('copy');
      document.body.removeChild(textArea);
      return successful;
    } catch (err) {
      console.error('Fallback copy failed:', err);
      return false;
    }
  }

  function closeFeaturesCard(card) {
    if (!card) return;
    card.classList.remove('is-features-open');
    var toggle = card.querySelector('[data-ug-card-features-toggle]');
    var overlay = card.querySelector('.ug-product-card__features-overlay');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    if (overlay) overlay.hidden = true;
  }

  function openFeaturesCard(card) {
    if (!card) return;
    card.classList.add('is-features-open');
    var toggle = card.querySelector('[data-ug-card-features-toggle]');
    var overlay = card.querySelector('.ug-product-card__features-overlay');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    if (overlay) overlay.hidden = false;
  }

  /** 事件委托：筛选 AJAX 后新卡片无需再绑监听 */
  function handleFeaturesToggleClick(event) {
    var button = event.target.closest('[data-ug-card-features-toggle]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    var card = button.closest('.ug-product-card_new');
    if (!card) return;

    var isOpen = card.classList.contains('is-features-open');

    document.querySelectorAll('.ug-product-card_new.is-features-open').forEach(function (openCard) {
      if (openCard !== card) closeFeaturesCard(openCard);
    });

    if (isOpen) {
      trackProductFeatures(button, true);
      closeFeaturesCard(card);
    } else {
      trackProductFeatures(button, false);
      openFeaturesCard(card);
    }
  }

  document.addEventListener('click', handleCopyClick);
  document.addEventListener('click', handleFeaturesToggleClick);

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-ug-card-features-toggle]')) return;
    if (event.target.closest('[data-ug-copy-data]')) return;
    if (event.target.closest('.copy-button[data-clipboard-text]')) return;
    if (event.target.closest('.ug-product-card__features-overlay')) return;
    document.querySelectorAll('.ug-product-card_new.is-features-open').forEach(function (card) {
      closeFeaturesCard(card);
    });
  });
})();

/** 筛选 morph 后刷新 Judge.me Preview Badge（仅调 App 公开 API） */
(function () {
  'use strict';

  function refreshJudgeMePreviewBadges() {
    if (typeof window.jdgmCacheServer !== 'undefined') {
      if (typeof window.jdgmCacheServer.reloadPreviewBadges === 'function') {
        window.jdgmCacheServer.reloadPreviewBadges();
        return;
      }
      if (typeof window.jdgmCacheServer.renderPreviewBadges === 'function') {
        window.jdgmCacheServer.renderPreviewBadges();
        return;
      }
    }

    if (
      typeof window.jdgm !== 'undefined' &&
      window.jdgm.customWidgets &&
      typeof window.jdgm.customWidgets.init === 'function'
    ) {
      window.jdgm.customWidgets.init();
    }
  }

  /* 等筛选 DOM morph 完成再刷新，避免扫到旧卡片 */
  document.addEventListener('ug:filter:morphed', refreshJudgeMePreviewBadges);
  document.addEventListener('shopify:section:load', refreshJudgeMePreviewBadges);
})();
